module.exports = __webpack_public_path__ + "media/images/new_logo_70-reverse-babc9a6b731c699b60e3b9a4aa33e6ea.svg";